import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {BenjiKIV} from "../../BenjiKIV";
import {BenjiKIVGameMode} from "../../server/BenjiKIVGameMode";
import {gsap} from "gsap";
import {BenjiKIVSound} from "../../sound/BenjiKIVSound";

/**
 * Created by Jerker Nord on 2022-11-10.
 */

export class BenjiKIVFreeSpinOutroRunner implements SimplePresentation {

    shouldRun():boolean {
        return BenjiKIV.model.data.mode == BenjiKIVGameMode.FREESPIN
            && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.NORMAL
            && !BenjiKIV.model.data.brokeTheBank;
    }

    start(controller:SimplePresentationRunnerController):void {
        const mainTL:gsap.core.Timeline = gsap.timeline();
        const amount:number = BenjiKIV.model.accumulatedRoundWin;

        const winRatio:number = (amount / BenjiKIV.model.gameData.playedBetValue);
        const countDuration:number = 1.871;

        let startDelay = 0.7;
        mainTL.add(gsap.to(this, {duration : startDelay})); //Small delay to allow animations to finish if now win last fs spin.
        mainTL.add(() => BenjiKIV.keypadPlugin.setZeroBetSpinCounter(-1));
        let aborted = false;

        const isWinBelowStake:boolean = BenjiKIV.isWinBelowStake();

        if(!isWinBelowStake) {
            mainTL.add(() => {
                //BenjiKIV.soundPlayer.playSound(TrueGritSound.FS_OUTRO_LOW_WIN);
            });
        }

        mainTL.add(BenjiKIV.fsOutroView.showOutro(() => this.fsIntroClosedCallback(controller, isWinBelowStake)));
        if(!isWinBelowStake) {
            mainTL.add(() => {
                BenjiKIV.soundPlayer.fadeMusic(0, 0, 0);
                if(BenjiKIV.model.wasFeatureBuy == true) {
                    if(amount < (BenjiKIV.getBuyFeaturePrice() * 0.10)) {
                        BenjiKIV.soundPlayer.playSound(BenjiKIVSound.FS_ENDS_BAD);
                    }else {
                        BenjiKIV.soundPlayer.playSound(BenjiKIVSound.FS_ENDS_GOOD);
                    }
                } else {
                    if(amount < (BenjiKIV.model.gameData.playedBetValue * 5)) {
                        BenjiKIV.soundPlayer.playSound(BenjiKIVSound.FS_ENDS_BAD);
                    } else {
                        BenjiKIV.soundPlayer.playSound(BenjiKIVSound.FS_ENDS_GOOD);
                    }
                }
            });
        }
        mainTL.add(() => controller.setSkipCallback(() => {
            aborted = true;
            mainTL.seek("end", false);
        }));
        mainTL.add(BenjiKIV.fsOutroView.getCountUp(amount, countDuration, isWinBelowStake));
        mainTL.addLabel("end");
        mainTL.add(() => controller.setSkipCallback());
        mainTL.add(BenjiKIV.fsOutroView.showButton());
        mainTL.add(() => BenjiKIV.soundPlayer.switchMusic(BenjiKIVGameMode.NORMAL))
        mainTL.add(() => BenjiKIV.soundPlayer.fadeMusic(0, 1, 1000));
    }

    private fsIntroClosedCallback(controller:SimplePresentationRunnerController, isWinBelowStake:boolean):void {
        const tl:gsap.core.Timeline = gsap.timeline({onComplete : () => controller.finish()});
        tl.add(() => {BenjiKIV.soundPlayer.playSound(BenjiKIVSound.CONTINUE_BUTTON)});
        tl.add(BenjiKIV.fsOutroView.hideOutro(isWinBelowStake));
    }
}